import { AuditLocation } from "../Locations/audit-location";

export class UserLocationLocationSave {
    public UserID: number;
    public IsGroup: boolean;
    public Locations: AuditLocation[] = [];

    constructor(values: Object = {}) {        
        Object.assign(this, values);
    }
}